import type { NextPage } from 'next'
import { useRouter } from 'next/router'
import style from './items.module.css'


interface IProps {
  boardCategory: string;
}

const Component: NextPage<IProps> = ({ boardCategory }) => {
  const Router = useRouter()
  // const defaultStepValue = Router.query.step || ''
  // const defaultStateValue = Router.query.state || ''
  const defaultTypeValue = Router.query.type || ''
  const defaultQueryValue = Router.query.query as string || ''

  const handlerSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (e.target instanceof HTMLFormElement && e.target.query) {
      const queries: Record<string, string> = {};
      // e.target.state.value && (queries.state = e.target.state.value);
      // e.target.step.value && (queries.step = e.target.step.value);
      // e.target.type.value && (queries.type = e.target.type.value);
      e.target.query.value && (queries.query = e.target.query.value);
      Router.push({
        pathname: `/board/${boardCategory}`,
        query: queries
      });
    }
  }

  return (
    <form onSubmit={handlerSubmit}>
      <div className='border border-[#DDDDDD] bg-[#F2F6FB] py-10 px-8'>
        <div className='flex justify-between space-x-8 h-[50px]'>
          <div className='flex items-center flex-grow space-x-6'>
            <p className={`${style.searchTitle} flex-shrink`}>검색어</p>
            <input
              type="search"
              name="query"
              minLength={1}
              maxLength={20}
              autoComplete='on'
              defaultValue={defaultQueryValue}
              placeholder='검색해주세요'
              className={`${style.searchInput} flex-grow`}
            />
          </div>
          <div className='flex-shrink'>
            <button type="submit" className='w-[150px] h-full bg-gg-blue text-[18px] text-white font-medium'>
              검색
            </button>
          </div>
        </div>
      </div>
    </form>
  )
}

export default Component
